import { render } from "./ReportUserDialog.vue?vue&type=template&id=1312e81a&scoped=true"
import script from "./ReportUserDialog.vue?vue&type=script&lang=js"
export * from "./ReportUserDialog.vue?vue&type=script&lang=js"

import "./ReportUserDialog.vue?vue&type=style&index=0&id=1312e81a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1312e81a"]])

export default __exports__